import React, { useState, useCallback } from 'react';

import ToastMessage from '../../components/ToastMessage';
import { SnackbarSeverityType } from '../../enums';
import SearchStudentFeeEntryPage from './SearchStudentFeeEntryPage';
import StudentFeeEntryContainer from '../StudentFeeEntry/StudentFeeEntryContainer';

import { StudentDetails } from './types';

const SearchStudentFeeEntryContainer: React.FC = () => {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<SnackbarSeverityType>(
    SnackbarSeverityType.success
  );
  const [showStudentFeeEntry, setShowStudentFeeEntry] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState('');
  const [studentName, setStudentName] = useState('');
  const [enrollmentNo, setEnrollmentNo] = useState('');
  const [parentName, setParentName] = useState('');
  const [studentProfileData, setStudentProfileData] =
    useState<StudentDetails[]>();
  const [isLoading, setIsLoading] = useState(false);
  const [isSearched, setIsSearched] = useState(false);

  const handleCloseToast = useCallback(() => {
    setToastOpen(false);
  }, []);

  const showToast = useCallback(
    (message: string, severity: SnackbarSeverityType) => {
      setToastMessage(message);
      setToastSeverity(severity);
      setToastOpen(true);
    },
    [setToastMessage, setToastSeverity, setToastOpen]
  );

  const handleFeeDetailsClick = (studentData: StudentDetails) => {
    setSelectedStudentId(studentData.id);
    setShowStudentFeeEntry(true);
  };

  const handleBackToSearch = () => {
    setShowStudentFeeEntry(false);
    setSelectedStudentId('');
  };

  return (
    <>
      {showStudentFeeEntry ? (
        <StudentFeeEntryContainer
          onShowToast={showToast}
          studentId={selectedStudentId}
          onBack={handleBackToSearch}
        />
      ) : (
        <SearchStudentFeeEntryPage
          onShowToast={showToast}
          onFeeDetailsClick={handleFeeDetailsClick}
          studentName={studentName}
          setStudentName={setStudentName}
          enrollmentNo={enrollmentNo}
          setEnrollmentNo={setEnrollmentNo}
          parentName={parentName}
          setParentName={setParentName}
          studentProfileData={studentProfileData}
          setStudentProfileData={setStudentProfileData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          isSearched={isSearched}
          setIsSearched={setIsSearched}
        />
      )}
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </>
  );
};

export default SearchStudentFeeEntryContainer;
